// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"uT","reco":"vT","products":"wT"};